import { useEffect } from 'react';

/* i18n */
import { useIntl } from 'react-intl';

/* Styles */
import styles from 'styles/recommendations-list.module.scss';
import layoutStyles from 'styles/layout.module.scss';

/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import { thumbsUpClick, thumbsDownClick, revertThumbsClick } from 'app/slices/ratingsSlice';

/* API */
import { rateItem } from 'lib/API';

/* Analytics */
import { trackEvent } from 'lib/analytics';
import TimeMe from "timeme.js";

/* Material UI and other UI Dependencies */
import Container from '@material-ui/core/Container';
import Typography from "@material-ui/core/Typography";
import withWidth from '@material-ui/core/withWidth';
import Box from '@material-ui/core/Box';
import RecommendationsCard from 'components/RecommendationsCard';
import { useSnackbar } from 'notistack';

const Training =({locale, width}) => {

  const intl = useIntl();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const responses = useSelector((state) => state.training.results);
  const ratingsLookup = useSelector((state) => state.ratings.results.lookup);

  const handleGlobalApplyClick = (item) => () => { 
    trackEvent('TRAINING_GLOBAL_APPLY', item);
  }
  const handleGlobalLikeClick = (item) => () => { 
    let previousRating = ratingsLookup[item.id];
    dispatch(thumbsUpClick({ ...item, rating: previousRating }));
    rateItem(item.id, 'liked', item, previousRating === 'liked').catch(() => {
      // We revert the UI changes in case of error
      dispatch(revertThumbsClick({ ...item, rating: previousRating }));
      enqueueSnackbar(intl.formatMessage({id:'app.error'}), {variant: 'error'});
    })
    trackEvent('TRAINING_GLOBAL_THUMBSUP', item);
  }
  const handleGlobalDislikeClick = (item) => () => {
    let previousRating = ratingsLookup[item.id];
    dispatch(thumbsDownClick({ ...item, rating: previousRating }));
    rateItem(item.id, 'disliked', item, previousRating === 'disliked').catch(() => {
      // We revert the UI changes in case of error
      dispatch(revertThumbsClick({ ...item, rating: previousRating }));
      enqueueSnackbar(intl.formatMessage({id:'app.error'}), {variant: 'error'});
    })
    trackEvent('TRAINING_GLOBAL_THUMBSDOWN', item);
  }

  useEffect(() => {
    TimeMe.stopTimer();
    TimeMe.setCurrentPageName("TRAINING");
    TimeMe.startTimer();
    return () => {
      console.log('Leaving Training')
    };
  }, []);

  return(
    <>
      <div className={styles.content}>
        <Container maxWidth="lg">
          <div className={styles.header__content}>
            <Typography variant="h1" component="h2" gutterBottom>
            {intl.formatMessage(
                {id: responses.length > 1 ? 'training.title' : 'training.titleSingular'},
                {nTrainings: responses.length}
              )}
            </Typography>
            <hr className={layoutStyles.separator} />
                <Box m={4} />
            {responses.map(item => (
              <RecommendationsCard
                type="training"
                item={item}
                link={item.link}
                rating={ratingsLookup[item.id]}
                onButtonClick={handleGlobalApplyClick(item)}
                onLikeClick={handleGlobalLikeClick(item)}
                onDislikeClick={handleGlobalDislikeClick(item)}
                rangeLabel={intl.formatMessage(
                  {id:'training.averagePay', description:'string'}
                )}
              />
            ))}
          </div>
        </Container>
      </div>
    </>
  )
}

export default withWidth()(Training);